import type { SentryConfig } from '../config'
import { defaultSentryConfig } from '../config'
import { SentryMonitor } from '../core/SentryMonitor'

// 全局 Sentry 实例
let globalSentryInstance: SentryMonitor | null = null

/**
 * 初始化全局 Sentry 实例
 * @param config 配置对象
 * @returns SentryMonitor 实例
 */
export function initGlobalSentry(config: Partial<SentryConfig> = {}): SentryMonitor {
  if (globalSentryInstance) {
    console.warn('Sentry already initialized, returning existing instance')
    return globalSentryInstance
  }

  const finalConfig = { ...defaultSentryConfig, ...config }
  globalSentryInstance = new SentryMonitor(finalConfig)

  return globalSentryInstance
}

/**
 * 获取全局 Sentry 实例
 * @returns SentryMonitor 实例或 null
 */
export function getGlobalSentry(): SentryMonitor | null {
  if (!globalSentryInstance) {
    // TODO H 做一个埋点的操作
  }
  return globalSentryInstance
}
